var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsOptional, IsString, ValidateNested, } from 'class-validator';
import { ReviewHintDto } from './ai-draft-payload.dto.js';
/**
 * `GET /ai-documentation/documentation-items/:itemId/provenance` (Spec § 3.4,
 * § 9): how a saved `AI_ASSISTED` entry came about — the transcript it was
 * made from, both providers and models, prompt and schema version, the
 * dictation's time and length, and the review hints as the reviewer saw
 * them. The audio is never part of it (deleted after save, ADR-0037).
 */
export class DocumentationItemProvenanceResponseDto {
    /** The cleaned transcript (a trimmed repetition loop is cut, Spec § 4.5). */
    transcriptText;
    sttProvider;
    sttModel;
    llmProvider;
    llmModel;
    promptVersion;
    schemaVersion;
    /** The dictation's `created_at`. */
    dictatedAt;
    durationSeconds;
    reviewHints;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentationItemProvenanceResponseDto.prototype, "transcriptText", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentationItemProvenanceResponseDto.prototype, "sttProvider", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentationItemProvenanceResponseDto.prototype, "sttModel", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentationItemProvenanceResponseDto.prototype, "llmProvider", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentationItemProvenanceResponseDto.prototype, "llmModel", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentationItemProvenanceResponseDto.prototype, "promptVersion", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DocumentationItemProvenanceResponseDto.prototype, "schemaVersion", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], DocumentationItemProvenanceResponseDto.prototype, "dictatedAt", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Object)
], DocumentationItemProvenanceResponseDto.prototype, "durationSeconds", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => ReviewHintDto),
    __metadata("design:type", Array)
], DocumentationItemProvenanceResponseDto.prototype, "reviewHints", void 0);
//# sourceMappingURL=documentation-item-provenance-response.dto.js.map